module.exports = __webpack_public_path__ + "static/media/sunshine_project.a0407648.jpg";